(function ($){
    $.noConflict();
    $(document).ready(function () {

        // Slideout Menu
        function slideoutMenu(){
            // Slideout Open
            $('.site-header__slideout-menu').click(function (){
                $('.slideout-menu').show("slide", { direction: "left" }, 500);
            });
            // Slideout Items
            $('.slideout-item').each(function (){
                if ($(this).find(".navigation-child").children().length > 0) {
                    $(this).addClass("slideout-active");
                }
            });
            // Slideout Item Active
            $(".slideout-active").click(function() {
                $(this).find(".slideout-top-item").toggleClass("open");
                $(this).find(".navigation-child").slideToggle();
                $(this).find(".slideout-down-arrow").toggleClass("rotate");
            });
            // Slideout Close
            $('.slideout-menu-close').click(function (){
                $('.slideout-menu').hide("slide", { direction: "left" }, 500);
                $(".slideout-top-item").removeClass("open");
                $(".navigation-child").hide();
                $(".slideout-down-arrow").removeClass("rotate");
            });
        }  

        slideoutMenu();

        // Mega Menu
        function megaMenu(){
            $('ul.header__submenu').each(function (){
                if ($(this).children().length > 5) {
                    $(this).addClass("plus");
                } else {
                    $(this).removeClass("plus");
                }
            });

            $("li.mega-menu-item").each(function(){
                if ($(this, "ul.header__submenu").find("li").length == 0 ){
                    $(this).addClass("blank");
                }
            });
        }
        
        megaMenu();

        // Slide-Panel-Menu
        function slidePanelMenu(){
            $('ul li.slide-panel-nav-main-item:has(ul)').addClass('has-menu');

            $('.site-header__slideout-menu').click(function(){
                $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar').addClass('active');
            });

            $('.slide-panel-close').click(function(){
                $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar').removeClass('active');
            });

            $('li.slide-panel-nav-main-item').click(function(){
                $("ul.navigation-child", this).slideToggle();
                $(this).toggleClass('active');
            });
        }

        slidePanelMenu();

        // Rerun Scripts in Shopify Theme Editor
        if (Shopify.designMode) {
            document.addEventListener('shopify:section:load', function(){
                slideoutMenu();
                megaMenu();
                slidePanelMenu();
            });
        }

    });
})(jQuery);